import React, { Component } from 'react';
import style from './field.row.less';
import i18n from '../i18n.jsx';

const _ = i18n;
const welcomeText = _(`We've sent you an email with a link to your questionnaire. You can resume and complete it anytime you want.`);
export default class QuestionnaireLinkRow extends Component {
    render() {
        return (
            <div className={style.fieldRow}>
                <div className={style.fieldRow__section}>
                    <div className={style.fieldRow__fieldWrapper}>
                        <p>{welcomeText}</p>
                    </div>
                </div>
            </div>
        );
    }
}
